var API_DOMAIN = "https://dhonicracker.com/api";

export default API_DOMAIN